import {Injectable, signal} from '@angular/core';

/**
 * Lets a page flag that the bug report is especially relevant right now, so the header's bug icon
 * can draw attention (e.g. a balance update error on the connections page). Pages set it while the
 * condition holds and clear it on destroy.
 */
@Injectable({providedIn: 'root'})
export class ReportBugAttentionService {
  readonly highlighted = signal(false);

  setHighlighted(value: boolean): void {
    this.highlighted.set(value);
  }
}
